import get from 'lodash/get';

import { TEMPLATE_TYPES } from 'common/constants';

import { SET_INITIALIZE } from '../actionTypes';
import { multiTemplateReviewActions } from '../reducer';

import fetchProposalContent from './fetchProposalContent';
import fetchProposalDetails from './fetchProposalDetails';

export default (initTemplate, proposalId, callback) => async (dispatch) => {
    dispatch(multiTemplateReviewActions[SET_INITIALIZE](true));
    const details = await dispatch(fetchProposalDetails(proposalId));
    if (details) {
        const contentId = get(details, 'content.id', null);
        if (contentId) {
            dispatch(fetchProposalContent(contentId, initTemplate));
            callback({
                contentId,
                id: details.id,
                name: details.name,
                type: TEMPLATE_TYPES.PROPOSAL_TYPE,
            });
        }
        dispatch(multiTemplateReviewActions[SET_INITIALIZE](false));
    } else dispatch(multiTemplateReviewActions[SET_INITIALIZE](false));
};
